import { useMutation, useQueryClient } from "@tanstack/react-query";
import { companyApi, companyQueryKeys } from "service/crm/api/company";

export const useUpdateCompanyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: companyApi.updateCompany,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: companyQueryKeys.all });
      queryClient.invalidateQueries({
        queryKey: companyQueryKeys.detail(variables.companyUuid),
      });
    },
  });
};

export const useDeleteCompanyMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (companyUuid: string) => companyApi.deleteCompany(companyUuid),
    onSuccess: (_data, companyUuid) => {
      queryClient.invalidateQueries({
        queryKey: companyQueryKeys.all,
        refetchType: "none",
      });
      queryClient.invalidateQueries({ queryKey: companyQueryKeys.lists() });
      queryClient.invalidateQueries({
        queryKey: companyQueryKeys.infiniteLists(),
      });
      queryClient.removeQueries({
        queryKey: companyQueryKeys.detail(companyUuid),
        type: "inactive",
      });
    },
  });
};